import { store } from '../../../store';
import {
  showTournamentDialog as showTournamentDialogAction,
  hideTournamentDialog as hideTournamentDialogAction,
  redirectTournamentGame as redirectTournamentGameAction,
} from '../../../modules/tournament';

/**
 * Shows tournament's dialog
 * @method showTournamentDialog
 * @memberof Tournament
 * @returns (void)
 */
export const showTournamentDialog = (routePrefix: string): void => {
  store.dispatch(showTournamentDialogAction(routePrefix));
};

/**
 * Hides tournament's dialog
 * @method hideTournamentDialog
 * @memberof Tournament
 * @returns (void)
 */
export const hideTournamentDialog = (): void => {
  store.dispatch(hideTournamentDialogAction());
};

/**
 * Triggers redirect to tournament game
 * @method redirectTournamentGame
 * @memberof Tournament
 * @param {number} gameId
 * @returns (void)
 * @example
 * Tournament.redirectTournamentGame(123);
 * // => Redirects to tournament game with id 123
 */
export const redirectTournamentGame = (gameId: number): void => {
  store.dispatch(redirectTournamentGameAction(gameId));
};
